import * as Yup from "yup";

export const branchCategoryValidationRules = () =>
  Yup.object().shape({
    name: Yup.string()
      .nullable()
      .required("Please provide a name for this category"),
    maximum: Yup.number()
      .min(1)
      .required("Please provide maximum for this category"),
  });

export default branchCategoryValidationRules;
